application.register("lib-gallery", class extends Stimulus.Controller {
    connect() {
        cssLoaded(()=>{
            inView(this.element,()=>{
                importStyle(cdnjs.lightgallery_css);
                importScript(cdnjs.lightgallery,()=>{
                    lightGallery(this.element, {
                        selector: ".item",
                        thumbnail: true,
                        showThumbByDefault: false,
                        actualSize: false
                    });
                });
            });
        });
    }
});